function vt(l, n) {
  for (var c = 0; c < n.length; c++) {
    var t = n[c];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(l, t.key, t);
  }
}
function xt(l, n, c) {
  return n && vt(l.prototype, n), l;
}
/*!
 * Observer 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var h, xe, y, Y, E, V, at, G, q, st, M, b, ut, gt = function() {
  return h || typeof window < "u" && (h = window.gsap) && h.registerPlugin && h;
}, ft = 1, R = [], x = [], U = [], j = Date.now, me = function(n, c) {
  return c;
}, mt = function() {
  var n = q.core, c = n.bridge || {}, t = n._scrollers, a = n._proxies;
  t.push.apply(t, x), a.push.apply(a, U), x = t, U = a, me = function(g, r) {
    return c[g](r);
  };
}, bt = function(n, c) {
  return ~U.indexOf(n) && U[U.indexOf(n) + 1][c];
}, Z = function(n) {
  return !!~st.indexOf(n);
}, _ = function(n, c, t, a, u) {
  return n.addEventListener(c, t, {
    passive: !a,
    capture: !!u
  });
}, p = function(n, c, t, a) {
  return n.removeEventListener(c, t, !!a);
}, ne = "scrollLeft", oe = "scrollTop", be = function() {
  return M && M.isPressed || x.cache++;
}, re = function(n, c) {
  var t = function a(u) {
    if (u || u === 0) {
      ft && (y.history.scrollRestoration = "manual");
      var g = M && M.isPressed;
      u = a.v = Math.round(u) || (M && M.iOS ? 1 : 0), n(u), a.cacheID = x.cache, g && me("ss", u);
    } else (c || x.cache !== a.cacheID || me("ref")) && (a.cacheID = x.cache, a.v = n());
    return a.v + a.offset;
  };
  return t.offset = 0, n && t;
}, ie = {
  s: ne,
  p: "left",
  p2: "Left",
  os: "right",
  os2: "Right",
  d: "width",
  d2: "Width",
  a: "x",
  sc: re(function(l) {
    return arguments.length ? y.scrollTo(l, ce.sc()) : y.pageXOffset || Y[ne] || E[ne] || V[ne] || 0;
  })
}, ce = {
  s: oe,
  p: "top",
  p2: "Top",
  os: "bottom",
  os2: "Bottom",
  d: "height",
  d2: "Height",
  a: "y",
  op: ie,
  sc: re(function(l) {
    return arguments.length ? y.scrollTo(ie.sc(), l) : y.pageYOffset || Y[oe] || E[oe] || V[oe] || 0;
  })
}, Dt = function(n, c) {
  return (c && c._ctx && c._ctx.selector || h.utils.toArray)(n)[0] || (typeof n == "string" && h.config().nullTargetWarn !== !1 ? console.warn("Element not found:", n) : null);
}, it = function(n, c) {
  var t = c.s, a = c.sc;
  Z(n) && (n = Y.scrollingElement || E);
  var u = x.indexOf(n), g = a === ce.sc ? 1 : 2;
  !~u && (u = x.push(n) - 1), x[u + g] || _(n, "scroll", be);
  var r = x[u + g], D = r || (x[u + g] = re(bt(n, t), !0) || (Z(n) ? a : re(function(k) {
    return arguments.length ? n[t] = k : n[t];
  })));
  return D.target = n, r || (D.smooth = h.getProperty(n, "scrollBehavior") === "smooth"), D;
}, ct = function(n, c, t) {
  var a = n, u = n, g = j(), r = g, D = c || 50, k = Math.max(500, D * 3), m = function(v, W) {
    var T = j();
    W || T - g > D ? (u = a, a = v, r = g, g = T) : t ? a += v : a = u + (v - u) / (T - r) * (g - r);
  }, X = function() {
    u = a = t ? 0 : a, r = g = 0;
  }, le = function(v) {
    var W = r, T = u, I = j();
    return (v || v === 0) && v !== a && m(v), g === r || I - r > k ? 0 : (a + (t ? T : -T)) / ((t ? I : g) - W) * 1e3;
  };
  return {
    update: m,
    reset: X,
    getVelocity: le
  };
}, B = function(n, c) {
  return c && !n._gsapAllow && n.preventDefault(), n.changedTouches ? n.changedTouches[0] : n;
}, lt = function(n) {
  var c = Math.max.apply(Math, n), t = Math.min.apply(Math, n);
  return Math.abs(c) >= Math.abs(t) ? c : t;
}, dt = function() {
  q = h.core.globals().ScrollTrigger, q && q.core && mt();
}, ht = function(n) {
  return h = n || gt(), h && typeof document < "u" && document.body && (y = window, Y = document, E = Y.documentElement, V = Y.body, st = [y, Y, E, V], h.utils.clamp, ut = h.core.context || function() {
  }, G = "onpointerenter" in V ? "pointer" : "mouse", at = S.isTouch = y.matchMedia && y.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in y || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0, b = S.eventTypes = ("ontouchstart" in E ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in E ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function() {
    return ft = 0;
  }, 500), dt(), xe = 1), xe;
};
ie.op = ce;
x.cache = 0;
var S = /* @__PURE__ */ (function() {
  function l(c) {
    this.init(c);
  }
  var n = l.prototype;
  return n.init = function(t) {
    xe || ht(h) || console.warn("Please gsap.registerPlugin(Observer)"), q || dt();
    var a = t.tolerance, u = t.dragMinimum, g = t.type, r = t.target, D = t.lineHeight, k = t.debounce, m = t.preventDefault, X = t.onStop, le = t.onStopDelay, P = t.ignore, v = t.wheelSpeed, W = t.event, T = t.onDragStart, I = t.onDragEnd, De = t.onDrag, we = t.onPress, Te = t.onRelease, Me = t.onRight, Se = t.onLeft, ke = t.onUp, Pe = t.onDown, Ye = t.onChangeX, Ee = t.onChangeY, Xe = t.onChange, Ce = t.onToggleX, Oe = t.onToggleY, Ae = t.onHover, Ge = t.onHoverEnd, ae = t.onMove, Fe = t.ignoreCheck, F = t.isNormalizer, He = t.onGestureStart, Le = t.onGestureEnd, Re = t.onWheel, Ve = t.onEnable, We = t.onDisable, Ie = t.onClick, J = t.scrollSpeed, H = t.capture, ze = t.allowClicks, pt = t.lockAxis, Ne = t.onLockAxis;
    this.target = r = Dt(r) || E, this.vars = t, P && (P = h.utils.toArray(P)), a = a || 1e-9, u = u || 0, v = v || 1, J = J || 1, g = g || "wheel,touch,pointer", k = k !== !1, D || (D = parseFloat(y.getComputedStyle(V).lineHeight) || 22);
    var z, L, K, se, ue, ge, N, e = this, fe = 0, de = 0, he = it(r, ie), pe = it(r, ce), Be = he(), qe = pe(), _t = ~g.indexOf("touch") && !~g.indexOf("pointer") && b[0] === "pointerdown", Q = Z(r), d = r.ownerDocument || Y, C = [0, 0, 0], O = [0, 0, 0], Ue = 0, je = function() {
      return Ue = j();
    }, A = function(o, s) {
      return (e.event = o) && P && ~P.indexOf(o.target) || s && _t && o.pointerType !== "touch" || Fe && Fe(o, s);
    }, yt = function() {
      e._vx.reset(), e._vy.reset(), L.pause(), X && X(e);
    }, $ = function() {
      var o = e.deltaX = lt(C), s = e.deltaY = lt(O), f = Math.abs(o) >= a, w = Math.abs(s) >= a;
      Xe && (f || w) && Xe(e, o, s, C, O), f && (Me && e.deltaX > 0 && Me(e), Se && e.deltaX < 0 && Se(e), Ye && Ye(e), Ce && e.deltaX < 0 != fe < 0 && Ce(e), fe = e.deltaX, C[0] = C[1] = C[2] = 0), w && (Pe && e.deltaY > 0 && Pe(e), ke && e.deltaY < 0 && ke(e), Ee && Ee(e), Oe && e.deltaY < 0 != de < 0 && Oe(e), de = e.deltaY, O[0] = O[1] = O[2] = 0), (se || K) && (ae && ae(e), K && (De(e), K = !1), se = !1), ge && !(ge = !1) && Ne && Ne(e), ue && (Re(e), ue = !1), z = 0;
    }, Ze = function(o, s, f) {
      C[f] += o, O[f] += s, e._vx.update(o), e._vy.update(s), k ? z || (z = requestAnimationFrame($)) : $();
    }, Je = function(o, s) {
      pt && !N && (e.axis = N = Math.abs(o) > Math.abs(s) ? "x" : "y", ge = !0), N !== "y" && (C[2] += o, e._vx.update(o, !0)), N !== "x" && (O[2] += s, e._vy.update(s, !0)), k ? z || (z = requestAnimationFrame($)) : $();
    }, _e = function(o) {
      if (!A(o, 1)) {
        o = B(o, m);
        var s = o.clientX, f = o.clientY, w = s - e.x, te = f - e.y, ve = e.isDragging;
        e.x = s, e.y = f, (ve || Math.abs(e.startX - s) >= u || Math.abs(e.startY - f) >= u) && (De && (K = !0), ve || (e.isDragging = !0), Je(w, te), ve || T && T(e));
      }
    }, ye = e.onPress = function(i) {
      A(i, 1) || i && i.button || (e.axis = N = null, L.pause(), e.isPressed = !0, i = B(i), fe = de = 0, e.startX = e.x = i.clientX, e.startY = e.y = i.clientY, e._vx.reset(), e._vy.reset(), _(F ? r : d, b[1], _e, m, !0), e.deltaX = e.deltaY = 0, we && we(e));
    }, ee = e.onRelease = function(i) {
      if (!A(i, 1)) {
        p(F ? r : d, b[1], _e, !0);
        var o = !isNaN(e.y - e.startY), s = e.isDragging && (Math.abs(e.x - e.startX) > 3 || Math.abs(e.y - e.startY) > 3), f = B(i);
        !s && o && (e._vx.reset(), e._vy.reset(), m && ze && h.delayedCall(0.08, function() {
          if (j() - Ue > 300 && !i.defaultPrevented) {
            if (i.target.click)
              i.target.click();
            else if (d.createEvent) {
              var w = d.createEvent("MouseEvents");
              w.initMouseEvent("click", !0, !0, y, 1, f.screenX, f.screenY, f.clientX, f.clientY, !1, !1, !1, !1, 0, null), i.target.dispatchEvent(w);
            }
          }
        })), e.isDragging = e.isGesturing = e.isPressed = !1, X && !F && L.restart(!0), I && s && I(e), Te && Te(e, s);
      }
    }, Ke = function(o) {
      return o.touches && o.touches.length > 1 && (e.isGesturing = !0) && He(o, e.isDragging);
    }, Qe = function() {
      return (e.isGesturing = !1) || Le(e);
    }, $e = function(o) {
      if (!A(o)) {
        var s = he(), f = pe();
        Ze((s - Be) * J, (f - qe) * J, 1), Be = s, qe = f, X && L.restart(!0);
      }
    }, et = function(o) {
      if (!A(o)) {
        o = B(o, m), Re && (ue = !0);
        var s = (o.deltaMode === 1 ? D : o.deltaMode === 2 ? y.innerHeight : 1) * v;
        Ze(o.deltaX * s, o.deltaY * s, 0), X && !F && L.restart(!0);
      }
    }, tt = function(o) {
      if (!A(o)) {
        var s = o.clientX, f = o.clientY, w = s - e.x, te = f - e.y;
        e.x = s, e.y = f, se = !0, (w || te) && Je(w, te);
      }
    }, nt = function(o) {
      e.event = o, Ae(e);
    }, ot = function(o) {
      e.event = o, Ge(e);
    }, rt = function(o) {
      return A(o) || B(o, m) && Ie(e);
    };
    L = e._dc = h.delayedCall(le || 0.25, yt).pause(), e.deltaX = e.deltaY = 0, e._vx = ct(0, 50, !0), e._vy = ct(0, 50, !0), e.scrollX = he, e.scrollY = pe, e.isDragging = e.isGesturing = e.isPressed = !1, ut(this), e.enable = function(i) {
      return e.isEnabled || (_(Q ? d : r, "scroll", be), g.indexOf("scroll") >= 0 && _(Q ? d : r, "scroll", $e, m, H), g.indexOf("wheel") >= 0 && _(r, "wheel", et, m, H), (g.indexOf("touch") >= 0 && at || g.indexOf("pointer") >= 0) && (_(r, b[0], ye, m, H), _(d, b[2], ee), _(d, b[3], ee), ze && _(r, "click", je, !1, !0), Ie && _(r, "click", rt), He && _(d, "gesturestart", Ke), Le && _(d, "gestureend", Qe), Ae && _(r, G + "enter", nt), Ge && _(r, G + "leave", ot), ae && _(r, G + "move", tt)), e.isEnabled = !0, i && i.type && ye(i), Ve && Ve(e)), e;
    }, e.disable = function() {
      e.isEnabled && (R.filter(function(i) {
        return i !== e && Z(i.target);
      }).length || p(Q ? d : r, "scroll", be), e.isPressed && (e._vx.reset(), e._vy.reset(), p(F ? r : d, b[1], _e, !0)), p(Q ? d : r, "scroll", $e, H), p(r, "wheel", et, H), p(r, b[0], ye, H), p(d, b[2], ee), p(d, b[3], ee), p(r, "click", je, !0), p(r, "click", rt), p(d, "gesturestart", Ke), p(d, "gestureend", Qe), p(r, G + "enter", nt), p(r, G + "leave", ot), p(r, G + "move", tt), e.isEnabled = e.isPressed = e.isDragging = !1, We && We(e));
    }, e.kill = e.revert = function() {
      e.disable();
      var i = R.indexOf(e);
      i >= 0 && R.splice(i, 1), M === e && (M = 0);
    }, R.push(e), F && Z(r) && (M = e), e.enable(W);
  }, xt(l, [{
    key: "velocityX",
    get: function() {
      return this._vx.getVelocity();
    }
  }, {
    key: "velocityY",
    get: function() {
      return this._vy.getVelocity();
    }
  }]), l;
})();
S.version = "3.12.2";
S.create = function(l) {
  return new S(l);
};
S.register = ht;
S.getAll = function() {
  return R.slice();
};
S.getById = function(l) {
  return R.filter(function(n) {
    return n.vars.id === l;
  })[0];
};
gt() && h.registerPlugin(S);
export {
  S as Observer,
  bt as _getProxyProp,
  it as _getScrollFunc,
  Dt as _getTarget,
  ct as _getVelocityProp,
  ie as _horizontal,
  Z as _isViewport,
  U as _proxies,
  x as _scrollers,
  ce as _vertical,
  S as default
};
